import styled from "styled-components";

export const Box = styled.div`
  body {
    // font-family: system-ui, -apple-system, sans-serif;
    background-color: #f3f4f6;
    margin: 0;
    padding: 2rem;
    line-height: 1.5;
  }
  .interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: system-ui, -apple-system, sans-serif;
  }

  .marketing-roi-container {
    max-width: 1024px;
    margin: 0 auto;
  }

  .header {
    text-align: center;
    margin-bottom: 2rem;
  }

  .header h1 {
    color: #1f2937;
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
  }

  .header p {
    color: #6b7280;
    margin: 0;
  }

  .card {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: 1rem;
    margin-bottom: 2rem;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .form-group label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 0.5rem;
  }

  .form-control,
  .form-select {
    padding: 0.75rem;
    border: 2px solid #e5e7eb;
    border-radius: 0.75rem !important;
    font-size: 1rem;
    transition: all 0.2s;
  }

  .form-control:focus,
  .form-select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .input-group-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
    background: none;
    border: none;
    z-index: 10;
  }

  .custom-input-group .form-control {
    padding-left: 2rem; /* Increased padding to add space between $ and placeholder */
  }

  .button-group {
    margin-top: 0.5rem;
  }

  .button-primary {
    background-color: #8cc540;
    color: white;
    border: none;
  }

  .button-primary:hover {
    background-color: #8cc540;
  }

  .button-secondary {
    background-color: #f3f4f6;
    color: #374151;
    border: 2px solid #e5e7eb;
  }

  .button-secondary:hover {
    background-color: #e5e7eb;
  }

  .metrics-grid {
    display: grid !important; /* Ensure CSS Grid overrides Bootstrap */
    grid-template-columns: repeat(
      auto-fit,
      minmax(200px, 1fr)
    ); /* Adjusted for better row fit */
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .metric-card {
    padding: 1.5rem;
    border-radius: 1rem;
    min-height: 180px; /* Consistent height */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden; /* Prevent overflow */
  }

  .metric-card .card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 0; /* Remove padding to avoid extra height */
  }

  .metric-card.blue {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  }

  .metric-card.green {
    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  }

  .metric-card.purple {
    background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%);
  }

  .metric-card.orange {
    background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  }

  .metric-icon {
    width: 2.5rem;
    height: 2.5rem;
    background: #3b82f6;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .metric-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 0.5rem;
  }

  .metric-value {
    font-size: 2rem;
    font-weight: 700;
    color: #1f2937;
  }

  .benchmarks-grid {
    display: grid !important; /* Ensure CSS Grid overrides Bootstrap */
    grid-template-columns: repeat(
      auto-fit,
      minmax(200px, 1fr)
    ); /* Adjusted for better row fit */
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .benchmark-card {
    background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
    padding: 1.5rem;
    border-radius: 1rem;
    border: 1px solid #e5e7eb;
    grey: 200px; /* Increased to accommodate content */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden; /* Prevent content overflow */
  }

  .benchmark-card .card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 0; /* Remove padding to avoid extra height */
  }

  .benchmark-title {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4b5563;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 1rem;
  }
  .cardFormRoi {
    padding: 1rem;
  }

  .benchmark-value {
    font-size: 1.5rem; /* Reduced to fit content */
    font-weight: 700;
    color: #1f2937;
  }

  .benchmark-comparison {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    font-size: 0.875rem; /* Reduced to prevent overflow */
  }

  .benchmark-arrow {
    font-size: 1.25rem;
  }

  .recommendations-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
  }

  .recommendation-group h3 {
    font-size: 1.25rem;
    color: #1f2937;
    margin-bottom: 1rem;
    font-weight: bold;
  }

  .recommendation-card {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    padding: 1rem;
    border-radius: 0.75rem;
    margin-bottom: 1rem;
  }

  .recommendation-card.alt {
    background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  }

  .section-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .section-title h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #1f2937;
  }

  .section-icon {
    width: 2rem;
    height: 2rem;
    background: #3b82f6;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .success {
    color: #059669;
  }

  .warning {
    color: #d97706;
  }

  .error {
    color: #dc2626;
  }

  @media (max-width: 991px) {
    .cardFormRoi {
      padding: 0rem;
    }
  }
  @media (max-width: 640px) {
    .metrics-grid,
    .benchmarks-grid,
    .recommendations-grid {
      grid-template-columns: 1fr;
    }
    .metric-card {
      margin-bottom: 0.5rem;
    }
    .benchmark-card {
      margin-bottom: 1rem;
    }
  }
`;
